import React from 'react';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-ink-900 px-4 py-10 sm:px-6 sm:py-14" data-id="element-18" data-mp="gvvli9ih9ake">
      <div className="mx-auto max-w-4xl text-center" data-id="element-19" data-mp="gxzvn96yz5t4">
        <h2 className="text-xl font-extrabold uppercase text-white sm:text-3xl" data-id="element-20" data-mp="vtxr0p92k64a">
          🎁 10 Bonos Estratégicos
        </h2>
        <p className="mt-1.5 text-[11px] font-extrabold uppercase tracking-[0.2em] text-gold-500 sm:text-xs" data-id="element-21" data-mp="qsi56uz2hvku">
          Siempre incluidos
        </p>

        <ul className="mt-6 grid gap-2 text-left sm:grid-cols-2" data-id="element-22" data-mp="zv9h0vvuutd0">
          {bonuses.map(bonus => <li key={bonus.number} className="flex items-center gap-3 rounded-lg border border-white/10 bg-ink-800 px-4 py-3" data-id="element-23" data-mp="1ejnip3hjcbrz">
              <span className="text-sm font-extrabold text-gold-500" data-id="element-24" data-mp="1nk26qalvw4z6">
                {bonus.number}
              </span>
              <span className="text-[13px] font-bold uppercase leading-snug text-white" data-id="element-25" data-mp="1jj9ur9lmnlz7">
                {bonus.title}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-md rounded-xl border border-gold-500/40 bg-ink-800 px-4 py-4 text-base font-extrabold text-white sm:text-lg" data-id="element-26" data-mp="3trnidg3hfg8s">
          Valor total de bonos:{' '}
          <span className="text-neutral-500 line-through" data-id="element-27" data-mp="7kp9mk844erf">$94.000</span>{' '}
          <span className="text-gold-500" data-id="element-28" data-mp="7ima99l2l9a1">→ GRATIS hoy</span>
        </p>
      </div>
    </section>;
}